import { render, staticRenderFns } from "./InvitationCode.vue?vue&type=template&id=b283430e&scoped=true"
import script from "./InvitationCode.vue?vue&type=script&lang=js"
export * from "./InvitationCode.vue?vue&type=script&lang=js"
import style0 from "./InvitationCode.vue?vue&type=style&index=0&id=b283430e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b283430e",
  null
  
)

export default component.exports